module.exports = __webpack_public_path__ + "static/media/Cuncaicha_highland_icon_200px.fc11439a.png";